var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "body-wrapper" }, [
    _c("div", { staticClass: "body-content gray" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-one-quarter" }),
        _c("div", { staticClass: "column" }, [
          _c("h1", [_vm._v("Delete Account")]),
          _c("div", { staticClass: "box" }, [
            _c("p", { staticClass: "mb-4" }, [
              _vm._v(
                " Are you sure you want to delete your account? This cannot be undone. "
              )
            ]),
            _c("p", { staticClass: "mb-4" }, [
              _vm._v(
                " We retain the following information that may have been associated with your account for historical, patron service, and compliance purposes: "
              )
            ]),
            _vm._m(0),
            _vm.loading
              ? _c("div", { staticClass: "has-text-centered" }, [
                  _c(
                    "progress",
                    {
                      staticClass: "progress is-primary",
                      attrs: { max: "100" }
                    },
                    [_vm._v("Loading...")]
                  ),
                  _c("p", [_vm._v("Checking your events...")])
                ])
              : _vm._e(),
            !_vm.loading && _vm.hasEventsInProgress
              ? _c("div", { staticClass: "notification is-warning" }, [
                  _c("p", [
                    _vm._v(
                      " You have events in progress that you are the sole user account on. We will be terminating these events and any payments for future performances will be refunded to patrons. "
                    )
                  ])
                ])
              : _vm._e(),
            _vm.error
              ? _c("div", { staticClass: "notification is-danger" }, [
                  _c("p", [_vm._v(_vm._s(_vm.error))])
                ])
              : _vm._e(),
            _c("div", { staticClass: "buttons mt-5" }, [
              _c(
                "button",
                { staticClass: "button", on: { click: _vm.cancel } },
                [_vm._v("Cancel")]
              ),
              _c(
                "button",
                {
                  staticClass: "button is-danger",
                  class: { "is-loading": _vm.deleting },
                  attrs: { disabled: _vm.loading || _vm.deleting },
                  on: { click: _vm.deleteAccount }
                },
                [_vm._v(" Delete ")]
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "column is-one-quarter" })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "mb-4 retention-list" }, [
      _c("li", [_vm._v("In progress and completed events")]),
      _c("li", [_vm._v("Artist profile information")]),
      _c("li", [_vm._v("Venue profile information")]),
      _c("li", [_vm._v("Festival profile and past festival records")]),
      _c("li", [_vm._v("Orders and order history information")]),
      _c("li", [_vm._v("Patron and will call records")]),
      _c("li", [_vm._v("Crash records and analytical data")]),
      _c("li", [_vm._v("Booking and artist communication data")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }